import { getIncorrectUrlLogoUrl } from "../common/BaseUtil"
import { useState, useEffect } from 'react';

export const CheckAndShowLogo = ({ imageUrl, alt, imageAlign, style }) => {
  const [status, setStatus] = useState('checking'); // 'checking', 'valid', 'invalid'

  useEffect(() => {
    const checkImageUrl = async () => {
      try {
        // URL에 HTTP 요청을 보내서 이미지가 호출 가능한지 확인
        const response = await fetch(imageUrl, { method: 'HEAD' });
        if (response.ok) {
          setStatus('valid'); // 유효한 URL
        } else {
          setStatus('invalid'); // 응답이 실패
        }
      } catch (error) {
        setStatus('invalid'); // 요청 실패
      }
    };

    checkImageUrl();
  }, [imageUrl]);

  return (
    <div style={{ textAlign: imageAlign }}>
      {status === 'checking' && <p>이미지 확인 중...</p>}
      {status === 'valid' && (
        <img
          src={imageUrl}
          alt={alt || '이미지'}
          style={style}
        />
      )}
      {status === 'invalid' && (
        <img
          src={getIncorrectUrlLogoUrl()}
          alt={alt || '이미지'}
          style={style}
        />
      )}
    </div>
  );
}